import { envConfig } from '../../../env';
import { Post } from '@/service/request/server';

const baseApi = () => {
    function queryAllProject() {
        return Post(`https://server.cottongame.com/cotton/queryProjectDetails`, { regionType: 'MAINLAND' }, {
            headers: {
                SkipToken: true
            }
        });
    }

    function codeRedeem(code, projectName) {
        return Post(`${envConfig.getCurrentApi()}/plat/giftCode/redeem`, {
            code: code,
            projectName: projectName
        });
    }

    return {
        queryAllProject, codeRedeem
    };
};

export const projectApi = baseApi();